import { Component, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SessionService } from 'app/core/services/session.service';
import { AmberApi } from 'app/core/models/api-helpers';
import { BuyerToSellerService } from './buyer-to-seller/buyer-to-seller.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionsService } from 'app/core/services/permissions.service';
import { RxComponent } from '../common/rx.component';

@Component({
  selector: 'itpx-buyer-to-seller-wrapper',
  templateUrl: './buyer-to-seller-wrapper.component.html',
  styleUrls: ['./buyer-to-seller-wrapper.component.css']
})
export class BuyerToSellerWrapperComponent extends RxComponent implements OnInit {
  private authorizedSignatory$: Observable<{ signatory: boolean }>;
  private signatoriesList$: Observable<any[]>;
  private hideStepper: boolean;
  private isPublic: boolean;
  private step: string;
  notificationSentMessage: string;

  constructor(
    private permissionsService: PermissionsService,
    private sessionService: SessionService,
    private service: BuyerToSellerService,
    private route: ActivatedRoute,
    private router: Router
  ) { 
    super();
  }

  ngOnInit() {
    let routeParams$ = this.route.queryParams
      .take(1).share();

    routeParams$.filter(params => params.public === 'true')
      .switchMap(params => this.service.getSignedRequests(params.id))
      .subscribe(res => {
        if (res && res.step != null) {
          this.step = res.step;
          this.hideStepper = true;
        } else {
          this.authorizedSignatory$ = Observable.of({ signatory: true });
          this.signatoriesList$ = Observable.of([{}]);
          this.isPublic = true;
        }
      }, error => this.router.navigate(['/logout'])
      );

    routeParams$.filter(params => params.public === 'false')
      .switchMap(_ => this.service.checkOngoingRequests())
      .subscribe(list => {
        if (0 === list.length) {
          this.authorizedSignatory$ = this.service.getEmployeeData(this.sessionService.getUserDetails().username)
            
            // .map(_ => ({ signatory: false })) //for testing purposes ONLY
            .map(user => ({ signatory: user.roles.some(conf => conf.configKey === 'contract-signer') }));
          this.signatoriesList$ = this.authorizedSignatory$.switchMap(input => {
            return (input.signatory) ? Observable.of([{}]) : this.service.listSignatories();
          });
          this.isPublic = false;
        } else {
          const response = list[0];
          this.step = response.step || '-2';
          if (!response.step) {
            Observable.zip(this.service.getEmployeeData(response.employeeEmail), 
            this.service.getEmployeeData(response.authorizedSignatoryEmail))
            .bindToLifecycle(this)
            .subscribe(([employee, signatory]) => 
            this.notificationSentMessage = '<h1>Sorry! An Invitation has already been sent.</h1>' +
            `<p>A user from your account, ${employee.firstName} ${employee.lastName} has sent an invitation to `+
            `${signatory.firstName} ${signatory.lastName} on ${this.service.formatDate(response.createdAt)}</p>` +
            '<p>You may close this window at any time</p>')
          }
          this.hideStepper = true;
        }
      })
  }

  getSignedRequests(id: string): Observable<any> {
    return this.service.getSignedRequests(id);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/buyer-to-seller-wrapper/buyer-to-seller-wrapper.component.ts